import { Box, Flex, Grid, GridItem, Image, Input, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, FormControl, FormLabel, Button, Center, Spinner, } from "@chakra-ui/react";
import MyDiv from "./tdsSlab.style";
import { CustomButton, CustomToast, ActionEditIcon, CustomTable } from "../../../../components";
import { useEffect, useState } from "react";
import PlusIcon from "../../../../assets/images/Vector.svg";
import { useFetch } from "../../../../hooks/useFetch";
import { IGroup } from "./modal";
import { Column } from "../../../../components/CustomTable/customTable";

const TdsSlab = () => {
    const [tdsSlab, setTdsSlab] = useState<IGroup[]>([]);
    const [DrawerOpen, setDrawerOpen] = useState(false);
    const [currentTdsSlab, setCurrentTdsSlab] = useState({ id: 0, amount_From: 0, amount_To: 0, percentage: 0, });
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);

    useEffect(() => {
        loadGroup();
    }, []);

    const loadGroup = async () => {
        const response = await fetchApi<IGroup[]>("Tds_Slab", "GET");
        if (response) setTdsSlab(response);
    };

    const handleAddNewTdsSlab = () => {
        setIsEditMode(false);
        setCurrentTdsSlab({ id: 0, amount_From: 0, amount_To: 0, percentage: 0, });
        setSelectedId(null);
        setDrawerOpen(true);
    };

    const handleEditTdsSlab = (tds_slab: IGroup) => {
        setDrawerOpen(true);
        setIsEditMode(true);
        setSelectedId(tds_slab.id);
        setCurrentTdsSlab(tds_slab);
    };

    const handleInputChange = (e: any) => {
        const { name, value } = e.target; 
        if (name === "amount_From" || name === "amount_To" || name === "percentage") {
         if (!/^\d*\.?\d{0,2}$/.test(value)) {
      return;
    }
        }   
        setCurrentTdsSlab((prev) => ({ ...prev, [name]: value, }));
    };

    const handleSubmit = async () => {
        if (isEditMode) {
            const response = await fetchApi(`Tds_Slab/${currentTdsSlab.id}`, "PUT", { id: currentTdsSlab.id, amount_From: currentTdsSlab.amount_From, amount_To: currentTdsSlab.amount_To, percentage: currentTdsSlab.percentage }, null, "Tds Slab updated successfully");

            if (response) setTdsSlab((prev) => prev.map((tds_slab) => (tds_slab.id === selectedId ? currentTdsSlab : tds_slab)));
        } else {
            const response = await fetchApi<IGroup>("Tds_Slab", "POST", { amount_From: currentTdsSlab.amount_From, amount_To: currentTdsSlab.amount_To, percentage: currentTdsSlab.percentage, }, null, "Tds Slab added successfully");
            if (response) setTdsSlab((prev) => [...prev, response]);
        }
        setDrawerOpen(false);
    };

    return (
        <MyDiv>
            <Box position="relative" minH="300px">
                {loading ? (
                    <Center position="absolute" top={0} left={0} right={0} bottom={0}>
                        <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
                    </Center>) : (
                    <>
                        <Flex className="page_heading flex_header">
                            <Text className="font-poppins text_semibold text_3xl">Tds Deduction Slab</Text>
                            <Flex gap={2}>
                                <CustomButton title="Add New TdsSlab" className=" btn font-poppins text_sm text_medium" rightIcon={<Image src={PlusIcon} className="logo" />} onClick={handleAddNewTdsSlab} />
                            </Flex>
                        </Flex>
                        <Grid className="grid_container">
                            <GridItem colSpan={12}>
                                <CustomTable value={tdsSlab} emptyMessage="No records found" >
                                    <Column<any> header="S. No" body={(_, index) => index + 1} />
                                    <Column<any> header="Amount From" body={(emp) => emp.amount_From} />
                                    <Column<any> header="Amount To" body={(emp) => emp.amount_To} />
                                    <Column<any> header="Percentage" body={(emp) => emp.percentage} />
                                    
                                    <Column<any>
                                        header="Action"
                                        body={(emp) => (
                                            <ActionEditIcon onClick={() => handleEditTdsSlab(emp)} />
                                        )}
                                    />
                                </CustomTable>

                            </GridItem>
                        </Grid>
                        <Drawer isOpen={DrawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="sm">
                            <DrawerOverlay />
                            <DrawerContent>
                                <DrawerCloseButton />
                                <DrawerHeader borderBottomWidth="1px">{isEditMode ? "Edit TdsSlab" : "Add New TdsSlab"}</DrawerHeader>
                                <DrawerBody display="flex" flexDirection="column" justifyContent="space-between" height="100%" >
                                 <Box>
                                        <FormControl mb={4} isRequired>
                                            <FormLabel>Amount From</FormLabel>
                                            <Input name="amount_From" value={currentTdsSlab.amount_From} onChange={handleInputChange} placeholder="Enter Amount From" />
                                        </FormControl>
                                  
                                   
                                        <FormControl mb={4} isRequired>
                                            <FormLabel>Amount To</FormLabel>
                                            <Input name="amount_To" value={currentTdsSlab.amount_To} onChange={handleInputChange} placeholder="Enter Amount To" />
                                        </FormControl>
                                    
                                   
                                        <FormControl mb={4} isRequired>
                                            <FormLabel>Percentage</FormLabel>
                                            <Input name="percentage" value={currentTdsSlab.percentage} onChange={handleInputChange} placeholder="Enter Percentage" />
                                        </FormControl>
                                   </Box>
                                    <Flex justify="flex-end" mt={4} mb={4} gap={2}>
                                        <Button className="font-poppins text_sm text_medium" onClick={() => setDrawerOpen(false)} style={{ backgroundColor: "#D92F34", color: "white" }}> Cancel
                                        </Button>
                                        <Button onClick={handleSubmit} className="font-poppins text_sm text_medium" style={{ backgroundColor: "#006838", color: "white" }}> {isEditMode ? "Update TdsSlab" : "Add TdsSlab"}</Button>
                                    </Flex>
                                </DrawerBody>
                            </DrawerContent>
                        </Drawer>
                    </>)}
            </Box>
        </MyDiv>
    );
};
export default TdsSlab;
